import { charsheetAPI, TABLE_USERS } from '../globals.js';
import axios from 'axios';

const getAllUsers = async () => {
                const userTable = TABLE_USERS
                // const queryAPI = charsheetAPI + '?TableName=' + userTable + '&UserName=' + userData.uniqueUser
                const queryAPI = charsheetAPI + '?TableName=' + userTable + '&UserName=' + 'all'
                const res = await axios.get( queryAPI );
                // console.log('getAllUsers:', res.data);
                return res.data;
            }

export default getAllUsers;